const toFloat = (value) => {
  const parsed = parseFloat(value);
  return isNaN(parsed) ? 0 : parsed;
};

const compare = (a, b) => {
  const numeric = (v) => v !== '' && v !== null && v !== undefined && !isNaN(Number(v));

  if (numeric(a) && numeric(b)) return Number(a) - Number(b);

  return String(a) < String(b) ? -1 : (String(a) > String(b) ? 1 : 0);
};

function matchPayoutPointsMapping(grid, result) {
  const rows = [...(grid || [])].sort((a, b) => compare(b.performanceResultMapValueOrFactor, a.performanceResultMapValueOrFactor));

  const matched = rows.find((row) => toFloat(result) >= toFloat(row.performanceResultMap)) || null;

  return { rows, matched };
}

export { matchPayoutPointsMapping };
